import styles from './Styles.module.scss'
import {ArrowIcon} from "../assets/Icons";

//previews = [{ id: 1, url: "url_1" }, { id:2, url: "url_2" }
function Preview({previews, handleTransitionClick, setPreviewIsShown}) {
    return (<div className={styles.previewBlock}>
        <div className={`${styles.previewContainer} ${styles.centerContent}`}>
        {previews.map((preview, index) => (
            <img className={styles.preview} src={preview.url} alt="" key={index} onClick={() => handleTransitionClick(preview.id)} />
        ))}
        </div>
        <div className={styles.centerContent}>
            <div className={styles.arrowContainer} onClick={() => setPreviewIsShown(false)}><ArrowIcon/></div>
        </div>
    </div>);
}

export default Preview;